export default __webpack_public_path__ + "static/media/3t.152cb4f5.jpg";